"use client"

import { SidebarLeft01Icon, SidebarRight01Icon } from "@hugeicons/core-free-icons"
import { useLocation, Link } from "react-router-dom"

import { SearchForm } from "@/components/search-form"
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"
import { Button } from "@/components/ui/button"
import { Separator } from "@/components/ui/separator"
import { useSidebar } from "@/components/ui/sidebar"
import { HugeiconsIcon } from "@hugeicons/react"
import { useDashboard } from "@/api/dashboards/useDashboards"

const PAGE_TITLES: Record<string, string> = {
  "/home": "Главная",
  "/inbox": "Входящие",
  "/tasks": "Задачи",
  "/meetings": "Митинги",
  "/projects": "Проекты",
  "/files": "Файлы",
  "/reports": "Отчёты",
  "/calendar": "Календарь",
  "/notifications": "Уведомления",
  "/team": "Команда",
  "/settings": "Настройки",
  "/support": "Поддержка",
}

export function SiteHeader({ onOpenSearch }: { onOpenSearch: () => void }) {
  const { toggleSidebar, open } = useSidebar()
  const { pathname } = useLocation()

  const segments = pathname.split("/").filter(Boolean)
  // segments[0] = workspace_slug, segments[1] = section, segments[2] = id
  const workspaceSlug = segments[0] ?? ""
  const section = segments[1] ?? ""
  const subId = segments[2]

  const sectionPath = "/" + section
  const sectionTitle = PAGE_TITLES[sectionPath] ?? "PMT"

  const isDashboard = section === "reports" && !!subId
  const { data: dashboard } = useDashboard(workspaceSlug, isDashboard ? subId : undefined)
  const dashboardName = dashboard?.name ?? subId

  return (
    <header className="sticky top-0 z-10 flex h-[56px] w-full items-center border-b bg-background pt-[env(safe-area-inset-top)] md:h-[43px] md:pt-0">
      <div className="grid h-full w-full min-w-0 grid-cols-[auto_minmax(0,1fr)] items-center gap-2 px-3 md:h-[43px] md:grid-cols-[1fr_minmax(0,300px)_1fr] md:px-4">
        <div className="flex min-w-0 items-center gap-2">
          <Button className="size-11 md:size-8" variant="ghost" size="icon" onClick={toggleSidebar}>
            <span className="transition-transform duration-200">
              <HugeiconsIcon
                icon={open ? SidebarLeft01Icon : SidebarRight01Icon}
                strokeWidth={2}
              />
            </span>
          </Button>
          <Separator orientation="vertical" className="mr-2 hidden self-stretch md:block" />
          <Breadcrumb className="hidden min-w-0 sm:block">
            <BreadcrumbList>
              {isDashboard ? (
                <>
                  <BreadcrumbItem>
                    <BreadcrumbLink asChild>
                      <Link to={`/${workspaceSlug}/reports`}>{sectionTitle}</Link>
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbSeparator />
                  <BreadcrumbItem>
                    <BreadcrumbPage>{dashboardName}</BreadcrumbPage>
                  </BreadcrumbItem>
                </>
              ) : (
                <BreadcrumbItem>
                  <BreadcrumbPage>{sectionTitle}</BreadcrumbPage>
                </BreadcrumbItem>
              )}
            </BreadcrumbList>
          </Breadcrumb>
        </div>
        <SearchForm onOpen={onOpenSearch} />
        <div className="hidden md:block" />
      </div>
    </header>
  )
}
